import { useMemo } from 'react';

import { useCheckout } from '../../../../../hooks/use-checkout';
import { EBEPaymentMethodsName } from '../../../../../contracts';
import { useAppConfig } from '../../../../../hooks/use-app-config';

const EXPRESS_PAYMENT_METHODS = [
  EBEPaymentMethodsName.link,
  EBEPaymentMethodsName.apple,
  EBEPaymentMethodsName.google,
  EBEPaymentMethodsName.paypal,
];

export function useAPMsToExclude() {
  const { checkoutData } = useCheckout();
  const { featureFlags } = useAppConfig();

  const shouldShowLinkAsApm = featureFlags?.checkout_display_link_express_as_apm_box;
  const checkoutConfigurations = checkoutData?.checkoutConfigurations;

  return useMemo(() => {
    const methodsToShowAsApm: EBEPaymentMethodsName[] = [];

    if (checkoutConfigurations?.shouldShowPayPalAsApm) {
      methodsToShowAsApm.push(EBEPaymentMethodsName.paypal);
    }

    if (checkoutConfigurations?.shouldShowGooglePayAsApm) {
      methodsToShowAsApm.push(EBEPaymentMethodsName.google);
    }

    if (shouldShowLinkAsApm) {
      methodsToShowAsApm.push(EBEPaymentMethodsName.link);
    }

    return EXPRESS_PAYMENT_METHODS.filter((pm) => !methodsToShowAsApm.includes(pm));
  }, [checkoutConfigurations, shouldShowLinkAsApm]);
}
